import basic from  './basic'
import service from  './service'
// import module from  './module'

const fr = {
  ...basic,
  ...service,
  // ...module,
}

export default fr
